let $infoContainer = document.querySelector(".cart-extra-info");

function showPopup(e) {
  let $tooltip = document.querySelector(".cart-extra-info__tooltip");

  if ($tooltip.classList.contains("d-none")) {
    $tooltip.classList.remove("d-none");
  } else {
    $tooltip.classList.add("d-none");
  }
}

function chooseDeviceType($infoContainer) {
  if ("ontouchstart" in document.documentElement) {
    $infoContainer.addEventListener("click", showPopup);
  } else {
    $infoContainer.addEventListener("mouseenter", showPopup);
    $infoContainer.addEventListener("mouseleave", showPopup);
  }
}

if ($infoContainer) {
  chooseDeviceType($infoContainer);
} else {
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let $infoContainer = document.querySelector(".cart-extra-info");
        if ($infoContainer) {
          chooseDeviceType($infoContainer);
        }
      }
    }
  })
  
  const cartDrawer = document.querySelector(".cart-drawer");
  observer.observe(cartDrawer, { childList: true })  
} 
